import { createFileRoute } from "@tanstack/react-router"
import { NotificationsPage } from "@/components/notifications-page"

export const Route = createFileRoute("/candidate/notifications")({
  component: CandidateNotificationsPage,
})

function CandidateNotificationsPage() {
  return (
    <NotificationsPage emptyCopy="Application updates, messages, and event reminders show up here." />
  )
}
